<div class="range-slider">
  <div class="range-slider__slider" (click)="onSliderClick($event)" #slider>
    <div class="range-slider__track">
      <div
        class="range-slider__track-highlight"
        [style.width]="trackHighlightWidth"
        [style.transform]="trackHighlightOffset"
        #trackHighlight
      ></div>

      <div class="range-slider__step-markers">
        <div
          class="range-slider__step-marker"
          *ngFor="let option of options; trackBy: trackBy"
        ></div>
      </div>
    </div>

    <div class="range-slider__knobs">
      <lib-range-slider-knob
        [sliderWidth]="sliderWidth"
        [sliderLeft]="sliderLeft"
        [sliderRight]="sliderRight"
        [options]="options"
        [currentOption]="minOption"
        (update)="updateLocalMin($event)"
        (updateDone)="selectMin($event)"
        #leftKnob
      ></lib-range-slider-knob>

      <lib-range-slider-knob
        [sliderWidth]="sliderWidth"
        [sliderLeft]="sliderLeft"
        [sliderRight]="sliderRight"
        [options]="options"
        [currentOption]="maxOption"
        (update)="updateLocalMax($event)"
        (updateDone)="selectMax($event)"
        #rightKnob
      ></lib-range-slider-knob>
    </div>
  </div>

  <div class="range-slider__dropdowns">
    <div class="range-slider__dropdown">
      <lib-range-slider-dropdown
        [options]="options"
        [currentOption]="minOption"
        [defaultOption]="defaultMinOption"
        [overlayPositions]="leftDropdownOverlayPositions"
        (update)="selectMin($event)"
      >
        <ng-template>
          <ng-container *ngTemplateOutlet="unitTemplate"></ng-container>
        </ng-template>
      </lib-range-slider-dropdown>
    </div>

    <div class="range-slider__dropdown">
      <lib-range-slider-dropdown
        [options]="options"
        [currentOption]="maxOption"
        [defaultOption]="defaultMaxOption"
        [overlayPositions]="rightDropdownOverlayPositions"
        (update)="selectMax($event)"
      >
        <ng-template>
          <ng-container *ngTemplateOutlet="unitTemplate"></ng-container>
        </ng-template>
      </lib-range-slider-dropdown>
    </div>
  </div>
</div>
